import { StrictMode } from "react";
import { EdisonTypography } from "./remote-entry";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <EdisonTypography title={"Components Running..."} variant={"h1"} />
  </StrictMode>
);
